"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    msgModalShutdownConfirm: {
        id: 'modal.shutdown.confirm',
        defaultMessage: 'Shutdown',
    },
    msgModalShutdownWorkbenchHeadline: {
        id: 'modal.shutdown.workbench.headline',
        defaultMessage: 'Shutdown Workbench',
    },
    msgModalShutdownWorkbenchDescription: {
        id: 'modal.shutdown.workbench.description',
        defaultMessage: 'You are about to shutdown this workbench. Please confirm that you are sure.',
    },
});
//# sourceMappingURL=modal.js.map